<script>
  import { capture } from '$lib/capture.js'
  import Dropdown from './Dropdown.svelte'
  import Symbol from '$lib/Symbol.svelte'
  import Button from '$lib/Button.svelte'
  import { text } from '$lib/text.js'
  import Autocomplete, {
    createAutocompleteBinding
  } from '$lib/Autocomplete.svelte'

  const autocomplete = createAutocompleteBinding()

  /**
   * @type {{
   *   name: string,
   *   label: string,
   *   align: 'left' | 'right',
   *   fallbackCountryCode?: string,
   *   onclose: () => void,
   *   onchange: (location: Schema.Location) => void,
   *   children?: Svelte.Snippet
   * }}
   */
  let { name, label, align, fallbackCountryCode, onclose, onchange, children } =
    $props()
</script>

<fieldset class="fieldset" use:capture>
  <div class="controls">
    <label for="journey-search-bar-{name}" class="field">
      <Symbol name="magnifier" size="sm" />
      <span class="u-hidden">{label}</span>
      <!-- svelte-ignore a11y_autofocus -->
      <input
        autofocus
        use:autocomplete
        type="search"
        minlength="2"
        autocorrect="off"
        autocomplete="off"
        autocapitalize="off"
        enterkeyhint="enter"
        name="{name}-input"
        class="input"
        placeholder={label} />
    </label>
    <div class="buttons">
      <noscript>
        <Button size="xs" type="submit">{$text`Search`}</Button>
      </noscript>
      <Button
        size="xs"
        name="panel"
        value=""
        title={$text`Cancel`}
        onclick={(event) => {
          onclose?.()
          event.preventDefault()
        }}>
        <Symbol name="cross" size="xs" />
        {$text`Cancel`}
      </Button>
    </div>
  </div>
  <Dropdown {align}>
    {@render children?.()}
    <Autocomplete
      onselect={onchange}
      oncancel={onclose}
      {fallbackCountryCode} />
  </Dropdown>
</fieldset>

<style>
  .fieldset {
    display: flex;
    width: 100%;
    padding-left: 0.5rem;
  }

  @media (width < 1000px) {
    .fieldset {
      height: 100%;
      padding: 0;
    }
  }

  .controls {
    display: flex;
    gap: 0.5rem;
    width: 100%;
  }

  .field {
    display: flex;
    gap: 0.5rem;
    align-items: center;
    width: 100%;
  }

  .input {
    flex: 1 1 auto;
    height: 100%;
    width: 100%;
    border: 0;
    font-size: 1rem;
    appearance: none;
    font-weight: normal;
  }

  .buttons {
    display: flex;
    gap: 0.5rem;
  }

  .buttons > :global(*) {
    display: flex;
  }

  @media (width >= 1000px) {
    .buttons {
      clip: rect(1px, 1px, 1px, 1px);
      height: 1px;
      overflow: hidden;
      position: absolute;
      width: 1px;
    }
  }
</style>
